module.exports = __webpack_public_path__ + "static/media/Navigation-tb-ico.c9446cac.svg";